import * as React from "react";
import * as Palette from "../../../../palette";
import { PropertiesTitle } from "./properties-title";
import { SearchResultTag } from "./search-result-tag";
import { pluralize } from "../../../../core/helpers";
import { inputs } from "../models/attribute-inputs";
import { buildInput } from "./helpers";
import { servicePath, userUrl } from "../../../routes";
import { advancedSearchPath } from "../../search/routes";
import { PageLayout } from "../../../../palette/layout/page-layout";
import { bulkEditServices_search_edges_node_Service } from "../models/__generated__/bulkEditServices";

const AkAddonIcon = require("@atlaskit/icon/glyph/addon").default;
const AkPersonIcon = require("@atlaskit/icon/glyph/person").default;
type Service = bulkEditServices_search_edges_node_Service;

export interface ConfirmStepProps {
  services: Service[];
  values: { [key: string]: any };
}

interface State {
  showConfirmationDialog: boolean;
}

export class ConfirmStep extends React.Component<ConfirmStepProps, State> {
  state = { showConfirmationDialog: false };

  render() {
    const { values, services } = this.props;

    return (
      <PageLayout title="Confirm">
        <p>
          The page summarizes the changes you are about to make to{" "}
          <Palette.BoldSpan>
            {this.props.services.length}{" "}
            {pluralize(this.props.services.length, "service", "services")}
          </Palette.BoldSpan>
          .<br />
          Do you wish to continue?
        </p>

        <h4>Updated Fields</h4>
        <UpdatedFields values={values} />

        <h4>Services that are going to be updated</h4>
        <UpdatedServices services={services} />
      </PageLayout>
    );
  }
}

export class UpdatedServices extends React.Component<
  { services: Service[] },
  {}
> {
  render() {
    const { services } = this.props;

    return (
      <Palette.Table
        className="bulk-edit-services-list"
        head={["", "", "Owner", "Platform"]}
        format={[
          ["small", "center"],
          ["big", "center"],
          ["small", "center"],
          ["small", "center"]
        ]}
        cells={services.map(result => this.renderServiceRow(result))}
      />
    );
  }

  renderServiceRow({ id, metadata }: Service) {
    const { tags, platform, owner } = metadata
      ? metadata
      : { tags: null, platform: "", owner: { id: "" } };

    const nameEl = (
      <Palette.Link to={servicePath(id)}>
        <Palette.Icon>
          <AkAddonIcon label="Service" />
        </Palette.Icon>
        <span className="search-result-name">{id}</span>
      </Palette.Link>
    );

    const tagsEl = (
      <SearchResultTag>
        {(tags || []).map(tag => (
          <Palette.Link key={tag} to={advancedSearchPath("services", tag, 1)}>
            <Palette.Badge>{tag}</Palette.Badge>
          </Palette.Link>
        ))}
      </SearchResultTag>
    );

    const ownerEl = (
      <Palette.Link to={userUrl(owner.id)}>
        <Palette.Icon>
          <AkPersonIcon label="User" />
        </Palette.Icon>
        {owner.id}
      </Palette.Link>
    );

    return [nameEl, tagsEl, ownerEl, platform];
  }
}

export class UpdatedFields extends React.Component<
  { values: { [key: string]: any } },
  {}
> {
  render() {
    const { values } = this.props;
    const updatedFields = inputs
      .filter(({ id }) => id in values)
      .map(input => [
        <PropertiesTitle>{input.title}</PropertiesTitle>,
        buildInput(input, values[input.id], [], () => {}, true)
      ]);

    return (
      <Palette.Table
        className="updated-fields"
        format={["small", "big"]}
        cells={updatedFields}
      />
    );
  }
}
